import { useEffect, useContext, useState } from "react";
import "../style/SignUpScreen.module.scss";
import { useFormik } from "formik";
import "react-phone-input-2/lib/style.css";
import {
    useNavigate,
    useLocation,
    useSearchParams,
} from "react-router-dom";
import { useFormat, } from "../../../hooks/useFormat";
import { AuthContext } from "../../../context/AuthContext";
import { usePhoneFormat } from "../../../hooks/usePhoneFormat";
import { useAgreements } from "../../../hooks/useAgreements";


export function useSignUpScreen() {
    const { formatDate, checkPassword } = useFormat();
    const { validateLocalPhone } = usePhoneFormat();
    const [metaDataTermsOfService, setMetaDataTermsOfService] = useState(null);
    const { acceptAgreement } = useAgreements();


    const parameters = useLocation();
    const [params] = useSearchParams();
    const route = useNavigate();


    const dateMin = new Date();
    useEffect(() => {
        dateMin.setMonth(dateMin.getMonth() - 12 * 13);
    }, []);


    const { signUp, setAlert } = useContext(AuthContext);


    const formik = useFormik({
        initialValues: {
            phoneNumber: !!parameters.state ? parameters.state.phoneNumber : "",
            name: "",
            birthDate: "",
            countryId: {
                id: "484",
                value: "México",
                ico: require("../../../components/assets/images/MX.png"),
            },
            password: "",
            termsOfService: true,
            code: params.get("code") != null ? params.get("code") : null,
            referralCode:
                params.get("referralCode") != null ? params.get("referralCode") : null,
        },
        onSubmit: async (values) => {
            const res = await signUp({
                birthDate: values.birthDate,
                countryId: values.countryId.id,
                name: values.name,
                password: values.password,
                phoneNumber: values.phoneNumber,
                referralCode: values.referralCode,
                termsOfService: values.termsOfService,
            })
            if (res) {
                if (await acceptAgreement(metaDataTermsOfService)) {
                    route("/SignUpOTPScreen", {
                        state: {
                            screen: "SignUpScreen",
                            accessToken: localStorage.getItem('registerToken'),
                            phoneNumber: values.phoneNumber,
                            newPassword: values.password,
                        },
                    });
                }
            }
        },
        validate: (values) => {
            console.log(values);
            const errors = {};
            if (!values.phoneNumber) {
                errors.phoneNumber = "Número de celular requerido";
            } else {
                if (!validateLocalPhone(values.phoneNumber))
                    errors.phoneNumber = "Ingrese un número de celular válido";
            }

            if (!values.birthDate) errors.birthDate = "Necesitamos tu fecha de nacimiento";
            const _date = new Date(values.birthDate);
            _date.setDate(_date.getDate() + 1);
            const dateMin = new Date();
            dateMin.setMonth(dateMin.getMonth() - 12 * 13);
            if (!(dateMin > _date)) {
                errors.birthDate = "Edad mínima 13 años"
            }

            if (!values.name) errors.name = "Necesitamos tu nombre para continuar con el registro";
            if (!values.password) {
                errors.password = 'Ingresa una contraseña.'
            } else {
                if (values.password.length < 6) {
                    errors.password = 'Tu contraseña debe tener al menos 6 caracteres.'
                } else {
                    if (!checkPassword(values.password)) {
                        errors.password = 'Escribe una contraseña valida. (Usa letras, numeros y signos)'
                    }
                }
            }
            if (!values.termsOfService) errors.termsOfService = ".";
            return errors;
        },
    });


    const dataSelectIco2 = [
        {
            id: "484",
            value: "México",
            ico: require("../../../components/assets/images/MX.png"),
        },
        {
            id: "840",
            value: "Estados Unidos",
            ico: require("../../../components/assets/images/US.png"),
        },
        {
            id: "841",
            value: "Colombia",
            ico: require("../../../components/assets/images/CO.png"),
        }
    ];


    return {
        formik,
        route,
        parameters,
        dataSelectIco2,
        metaDataTermsOfService,
        setMetaDataTermsOfService
    }
}